export interface Filters {
  action: string;
  resource: string;
  from: string;
  to: string;
}

export const EMPTY_FILTERS: Filters = { action: '', resource: '', from: '', to: '' };

export function buildAuditQuery(filters: Filters, cursor?: string | null): string {
  const params = new URLSearchParams();
  if (filters.action) params.set('action', filters.action);
  if (filters.resource.trim()) params.set('resource', filters.resource.trim());
  // Las fechas del formulario son días locales: desde el inicio del día "desde" hasta el fin del día "hasta".
  if (filters.from) params.set('from', new Date(`${filters.from}T00:00:00`).toISOString());
  if (filters.to) params.set('to', new Date(`${filters.to}T23:59:59.999`).toISOString());
  if (cursor) params.set('cursor', cursor);
  const qs = params.toString();
  return `/v1/audit${qs ? `?${qs}` : ''}`;
}

